import axios from "axios";
import { createTransactionID } from "../utils";

const win: any = window;

const apigeeConfig = {
  api: {
    baseURL: win["apigee_base_api_url"],
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      'x-correlation-id': createTransactionID(true),
      'x-channel-id': "PORTAL",
    },
  },
}

export const apigeeApi = axios.create({ ...apigeeConfig.api });

apigeeApi.defaults.validateStatus = function () {
  return true;
};

apigeeApi.interceptors.request.use(
  async (conf: any) => {
    conf.headers["X-Transaction-Id"] = createTransactionID();
    conf.headers["Authorization"] = `Bearer ${win['bmToken']}`;
    conf.headers["cem-key"] = win["cem_key"];
    return conf;
  },
  (err) => {
    console.log("error in getting ", err);
  }
);

apigeeApi.interceptors.response.use(
  async (response: any) => {
    return response;
  },
  async (error: any) => {
    if (!!win["errorPageURL"]) {
      document.location.href = win["errorPageURL"];
    }
    return error;
  }
);

const getZoneODBCoverageByLocation = (data: any) => {
  return apigeeApi.post(`${win["apigee_base_api_url"]}/v1/dp/iib/getGISZoneCoverageByLocation`, data);
};

const setupFeeLead = (data: any) => {
  return apigeeApi.post(`${win["apigee_base_api_url"]}/v1/dp/iib/FTTHODBSetupFeeLead`, data);
};


export { getZoneODBCoverageByLocation, setupFeeLead };
